import React from "react";
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import App from "./App";
import { store } from "./store/store";
import PersistProvider from "./store/providers/persist-provider"; 
import { fetchProductsIfNeeded } from "./data/productApi";
import { injectSeoScripts } from "./utils/injectSeoScripts";
import { loadKonversaWidgetSiHabilitado } from "./utils/loadKonversaWidget";
import 'animate.css';
import 'swiper/swiper-bundle.min.css';
import "yet-another-react-lightbox/styles.css";
import "yet-another-react-lightbox/plugins/thumbnails.css";
import "./assets/scss/style.scss";
import "./i18n";
 
// Carga inicial de productos si es necesario
store.dispatch(fetchProductsIfNeeded());

// Tags de tracking (GTM, FB Pixel, etc.) configurables desde el admin
injectSeoScripts();

// Chat de Konversa: solo si el build define REACT_APP_KONVERSA_WIDGET_KEY (stage)
// y el super_admin lo tiene prendido en Configuración
loadKonversaWidgetSiHabilitado();

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
    <Provider store={store}>
      <PersistProvider>
        <App />
      </PersistProvider>
    </Provider>,
  document.getElementById("root")
);
